import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck, AfterContentInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined, isNotNullOrUndefinedOrEmpty } from '../../../_infrastructure/objectUtils';

import { confirmRemoveFromList } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { SecurityService } from '../../../_infrastructure/Security/SecurityService';
import { WorkflowComponentNew } from '../../workflow-new.component';

//import DateHelpers from '../../../_infrastructure/DateHelpers';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
import { DocumentosObservableService } from '../../../_infrastructure/Documents/DocumentosObservable';
import { Subscription } from 'rxjs';
import { PersonType } from '../../../_infrastructure/Models/const.personType';
import ArrayHelpers from '../../../_infrastructure/ArrayHelper';
interface ResultDocumentVM {
  mandatoryFileAlreadyExists: boolean;
  indexOfMandatoryFileEntry: number;
}

@Component({
  selector: 'documentation-pm',
  templateUrl: './documentation-pm.component.html',
  standalone: false
})
export class DocumentationPMComponent implements OnInit, OnDestroy, ICardComponent, DoCheck,AfterContentInit {


  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  public  cardData: models.DocumentationPM = { } as models.DocumentationPM;

  private mainSubscription: Subscription = new Subscription();



  private onCardDataChanged() {


  }

  public cardConfiguration: models.CardVM;

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.fileTypes)
  public fileTypes: models.DimensionVM[];
  @CommonData(DomainCodes.documentDesignationType)
  public designationTypes : models.DimensionVM[];
  public workflowInstanceId: string;

  public isWorkflowOnSubscriber: boolean = false;
  public isWorkflowIncapacity: boolean = false;
  public isMandatoryDocumentation: boolean;

/*  public parentWorkflow: WorkflowComponentNew;*/
  public workflowDropdowns: models.WorkflowDropdownsVM = <models.WorkflowDropdownsVM>{}

  public showAddDocButton: boolean = false;

  public version2: boolean;

  public professionalClass: string;

  public PGPAS: boolean;
  public isAtendimento: boolean;

  public initialMandatory: models.DocumentPM_VM[]=[];

  public readonlyAdditionalDoc: boolean;
  public parentWorkflow: WorkflowComponentNew;
  private firstTimeUpdating: boolean = false;
  public workflowCode: string;

  constructor(
    private modalService: ModalService,
    private activeRoute: ActivatedRoute,
    private securityService: SecurityService,
    private documentsObservableService: DocumentosObservableService
  ) {
    this.activeRoute.parent.paramMap.subscribe((params: ParamMap) => {
      this.workflowInstanceId = params.get('workflowInstanceId');
    });

  }
    
 
  ngOnInit(): void {
    this.showAddDocButton = true;
    this.workflowCode = this.parentWorkflow.workflowCode;
  }



  ngAfterContentInit(): void {
    const instance = (<models.WorkflowTemplateVM_PM>this.parentWorkflow?.workflowInstance);
    const beneficiariesList = instance.StepBeneficiary.Beneficiary.beneficiaryList;
    const isSubmited = this.parentWorkflow?.stateCode == "C" && this.parentWorkflow?.statePhase == "C";
    if (isSubmited) {
      this.cardData.documentsList.forEach((doc: models.DocumentPM_VM) => {

        const existeBeneficiario = beneficiariesList.find(el => el.beneficiaryID == doc.beneficiaryID);
        if (existeBeneficiario != null && existeBeneficiario != undefined) {
          doc.ownerName = existeBeneficiario.beneficiaryName;
        } else {
          if (doc.beneficiaryID == PersonType.Deceased) { //falecido
            doc.ownerName = instance.StepDeceased.DeceasedIdentification.subscriberName;

          } else {
            if (doc.beneficiaryID == PersonType.Sender) { //requerente
              doc.ownerName = instance.StepSender.SenderIdentification.name;
            } 
          }
        }
        

        
      });
    } else {
      if (
        this.cardData.documentsList.length == 0
      ) {
        this.documentsObservableService.internalArray.forEach((doc: models.DocumentosObservableVM) => {
          const newDoc: models.DocumentPM_VM = {
            designationTypeCode: doc.documentTipologyCode,
            designationTypeDescription: doc.documentTipologyDescription,
            beneficiaryID: this.documentsObservableService.getBeneficiaryByNIF(
              beneficiariesList,
              doc.ownerNif, doc.ownerName, doc.ownerCode),
            ownerName: doc.ownerName,
            fileOwnerTypeCode: doc.ownerCode,
            isMandatoryFile: true,
            isNecessary: true,
            nif: doc.ownerNif


          } as models.DocumentPM_VM;
          this.cardData.documentsList.push(newDoc);
        });
      } else {
        this.cardData.documentsList
          .forEach((doc: models.DocumentPM_VM) => {

            const existeBeneficiario = beneficiariesList.find(el => el.beneficiaryID == doc.beneficiaryID);
            if (existeBeneficiario != null && existeBeneficiario != undefined) {
              doc.ownerName = existeBeneficiario.beneficiaryName;
            } else {
              if (doc.beneficiaryID == PersonType.Deceased) { //falecido
                doc.ownerName = instance.StepDeceased.DeceasedIdentification.subscriberName;

              } else {
                if (doc.beneficiaryID == PersonType.Sender) { //requerente
                  doc.ownerName = instance.StepSender.SenderIdentification.name;
                }
              }
            }



          });

        // Verificar se os documentos obrigatórios ainda são necessários
        const mandatoryFiles = this.cardData.documentsList.filter(el => el.isMandatoryFile);
        const toRemove = mandatoryFiles.filter(el => {
          const notExistInInternalArray = this.documentsObservableService.internalArray.filter(doc => {
            return doc.documentTipologyCode == el.designationTypeCode && doc.beneficiaryID == el.beneficiaryID;
          }).length == 0;
          const hasFileId = isNotNullOrUndefinedOrEmpty(el.fileID) && el.fileID > 0;
          return notExistInInternalArray && !hasFileId;
        })

        this.cardData.documentsList = ArrayHelpers.removeItems(this.cardData.documentsList, toRemove);

      }

    }

    // Isto serve adicionar os documentos caso não tenham chegado até aqui



  }




  public showDocRow(docItem: models.DocumentPM_VM) {
    let isMandatoryFile = (docItem.isMandatoryFile?.toString()?.toLowerCase() === 'true');
    if (isMandatoryFile) {
      return this.initialMandatory.find((v, i, a) => v === docItem) != undefined;
    }
    return true;
  }

  isWorkflowOnSubscriberAtendimento() {
    if (this.isAtendimento && !this.PGPAS)
      return true;
    else
      if (this.isAtendimento && this.PGPAS)
        return false;

    return false;
  }


  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously
    if (isUndefined(this.cardData.documentsList))
      this.cardData.documentsList = [];
    
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }

  public markAsMandatory(docItem: models.DocumentPM_VM): boolean {
    
    return docItem.isMandatoryFile?.toString()?.toLowerCase() == 'true';


  }

  findInitialMandatory(docsList: models.DocumentPM_VM[]): models.DocumentPM_VM[] {
      let result = [];

      for (let i = 0; i < docsList.length; i++) {
        if (docsList[i].isMandatoryFile?.toString()?.toLowerCase() === 'true') {
          result.push(docsList[i])
        }
      }

      return result;
    
  }

  onDocumentationChanged(newDocumentList: models.DocumentPM_VM[]) {

    // Refresh intitial mandatory list
    this.initialMandatory = this.findInitialMandatory(newDocumentList) ?? [];

    this.cardData.documentsList = newDocumentList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;

  }
  
  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result)
          this.expandedRowIndex = null;
      });
    }
    event.stopPropagation();
  }

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }


}
